<template>
    <div class="main-bg">
        <!-- <banner :bgImage="bgImage" class="news-banner" :title="bannerInfo.title" :subTitle="bannerInfo.subTitle" :crumbList="crumbList">
        </banner> -->
        <customBreadcrumb :crumbList="crumbList"></customBreadcrumb>
        <div class="wrap">
            <div class="detail" v-if="status==0">
                <div class="detail-left">
                    <h1 class="title">{{info.title}}</h1>
                    <div class="date">{{t('news.time')}}：{{getMonthYearDay(info.showTime || '')}}</div>
                    <div class="content" v-html="info.content"></div>
                    <div class="link-btn pre" v-if="info?.previousOne?.id">
                        <nuxt-link :to="'/news/'+info.previousOne.id">{{t('news.pre')}}：{{info.previousOne.title}}</nuxt-link>
                    </div>
                    <div class="link-btn next" v-if="info?.nextOne?.id">
                        <nuxt-link :to="'/news/'+info.nextOne.id">
                            {{t('news.next')}}：{{info.nextOne.title}}
                        </nuxt-link>
                    </div>
                </div>
                <div class="detail-right">
                    <h2>{{t('news.otherNews')}}</h2>
                    <div class="news-list">
                        <newsItem :item="item" v-for="(item,index) in info && info.relatedInformation" :key="index" source="news"></newsItem>
                    </div>
                </div>
            </div>
            <error :status="status" v-if="status>0"></error>
        </div>
    </div>
</template>

<script setup lang="ts">
// 1. 导入必要的依赖
import { ref, watch } from 'vue'
import useServerRequest from '@/composables/useServerRequest'
import type { NewsDetail, configParams, configResponse, NewsDetailParams,bannerConfig } from '~/types'
import { useI18n } from 'vue-i18n'
const { locale,t } = useI18n()

import { getMonthYearDay,handleApiResponse } from "@/utils/utils"
import { useRoute } from 'vue-router'
const config = useRuntimeConfig()
const cmsurlStrategy = config?.public?.cmsStrategy

// 2. 获取当前路由和语言
const route = useRoute()

// 3. 初始化响应式数据
const bgImage = ref<string>(staticURL('/banner/news-banner.webp'))
const crumbList = ref([
    { name: t("common.aboutUs"), path: "/about" },
    { name: t("common.newsInfo"), path: "/news" },
    { name: t("common.newsInfoDetail")}
])

// 4. 详情数据
const status = ref<number>(0)
const info = ref<NewsDetail>({}) 

// 5. 配置信息（keywords 等仍可读频道配置；title/desc 优先用详情自身）
const seo = ref<configResponse['pageValue']['seo']>({
    title: '',
    keywords: '',
    desc: ''
})
const bannerInfo = ref<bannerConfig>({})
const infoParams = ref<configParams>({
    pageCode: "NEWS_INFO"
})

/** 去掉 HTML 标签，压成纯文本（详情 desc 用） */
const stripHtmlToText = (html = '') =>
    html
        .replace(/<script[\s\S]*?<\/script>/gi, '')
        .replace(/<style[\s\S]*?<\/style>/gi, '')
        .replace(/<[^>]+>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/gi, "'")
        .replace(/\s+/g, ' ')
        .trim()

/** 正文前 N 字 + 省略号；不足 N 字不加省略号 */
const seoDescFromContent = (content?: string, max = 80) => {
    const text = stripHtmlToText(content || '')
    if (!text) return ''
    return text.length > max ? `${text.slice(0, max)}...` : text
}

// 6. 获取详情数据
const getDetail = async (id: number) => {
     const { data } = await useServerRequest<NewsDetail>(
        `news-detail-${id}`, // 唯一 key，避免缓存问题
        `${cmsurlStrategy}/getNewInformation/${id}`, 
        { method: 'GET', language: locale.value }
    )
    const res = data?.value
    const result = handleApiResponse(res)
    if (!result.success) {
        status.value = result.status
        return
    }
    // 更新状态
    info.value = res?.data || {}
}

// 7. 获取配置信息
const getInfo = async () => {
    try {
        const { data } = await useServerRequest<configResponse>(
            'news-detail-info',
            `${cmsurlStrategy}/getPageConfig`,
            { method: 'GET', params: infoParams.value, language: locale.value }
        )
        const getInfoData = data?.value?.data?.pageValue
        seo.value=getInfoData?.seo
        bannerInfo.value = getInfoData?.banner?.[0] || {}; // 链式判断 + 默认值
        bgImage.value = bannerInfo.value.file ? bannerInfo.value.file : bgImage.value
        console.log(getInfoData)
        
    } catch (error) {
    }
}

// 8. 监听路由 id 变化
watch(
    () => route.params.id,
    (newId) => {
        console.log('🔍 路由 id 变化:', newId)
        if (newId) {
            const id = +newId
            getDetail(id)
            getInfo() // 路由变化时重新获取配置信息
        }
    },
    { immediate: true,deep:true } // 初始化时执行一次
)

// 9. TDK：title/desc 用详情自身；keywords 仍用 NEWS_INFO 频道配置兜底
useHead({
    title: () => info.value?.title || seo.value?.title || '',
    meta: [
        {
            name: 'keywords',
            content: () => seo.value?.keywords || ''
        },
        {
            name: 'description',
            content: () =>
                seoDescFromContent(info.value?.content, 80) ||
                info.value?.subTitle ||
                seo.value?.desc ||
                ''
        }
    ]
})
</script>

<style lang="scss" scoped>
    @use '@/assets/css/news.scss';
</style>